
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const redeem_orderApi = createAsyncThunk("redeem_order", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/redeem_order",{ params });
  return response.data;
});

const redeem_orderSlice = createSlice({
  name: "redeem_order",
  initialState: {
    redeem_order: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(redeem_orderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeem_orderApi.fulfilled, (state, action) => {
        state.redeem_order = action.payload;
        state.loading = false;
      })
      .addCase(redeem_orderApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default redeem_orderSlice.reducer;
